export class TimeProfile {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
}

export default TimeProfile;